import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MunilyIconAreaCardConfig, MunilyIconAreaCardIconSet, MunilyIconAreaCardStatus } from './icon-area-card.types';

@Component({
  selector: 'common-icon-area-card',
  templateUrl: './icon-area-card.component.html',
  styleUrls: ['./icon-area-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAreaCardComponent {
  @Input() title: MunilyIconAreaCardConfig['title'] = '';
  @Input() status: MunilyIconAreaCardStatus = 'default';
  @Input() disabled: boolean = false;

  @Input() imageUrl: MunilyIconAreaCardConfig['imageUrl'] = undefined;
  @Input() icon: MunilyIconAreaCardConfig['icon'] = undefined;
  @Input() iconSet: MunilyIconAreaCardIconSet = 'material-symbols-rounded';

  @Output() select = new EventEmitter<void>();

  onClick(): void {
    if (this.disabled) return;
    this.select.emit();
  }
}

